import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const GameInformationPage = loadable(() =>
  withDefaultLoaderModifiers(import("./GameInformationPage"))
);
